import React from "react";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";

import { getListOfAttachmentsByUserId, downloadAttachment, getListOfAttachmentsByUserIdForFolderQuery, getCategoryManagementListQuery, getListOfCategoriesForCategoryViewUserQuery } from "../../services/graphql/queries/category-management";
import { getAccessPermisionQuery } from "../../services/graphql/queries/accessPermission";

import Pagination from "../MobileCommon/Pagination";
import NotAccessible from "../MobileCommon/NotAccessible";
import ReactModal from "../MobileCommon/ReactModal";


import { PAGINATION_OFFSET_VALUE, DO_NOT_ACCESS_MESSAGE, SET_TIMEOUT_VALUE }  from "../../constants/app-constants";
import { errorMessage } from "../../miscellaneous/error-messages";

import downloadSvg from "../../static/images/download.svg"
import gridSvg from "../../static/images/grid.svg"
import SelectComponent from "../Common/form-component/SelectComponent";
import { errorMsg, successMsg } from "../../miscellaneous/react-toastify";

// import CategoryFilter from "./CategoryFilter";

const FileSaver = require("file-saver");
const mime = require("mime-types");

const CATEGORY_MANAGEMENT_MODULE_ID = 15;
const CATEGORY_MANAGEMENT_FEATURE_ID = 243;

class CategoryList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error:"",
      tags:"",
      projectId: "",
      searchedTags:"",
      pageOfItems:[],
      currentPage: 1,
      offset: PAGINATION_OFFSET_VALUE,
      reactModalVisible: false,
      requireCancel: false,
      modalMessage: DO_NOT_ACCESS_MESSAGE,
      accessSpecifier: {},
      userDetail: {
        entityType: "",
      },
      projectNameList: [],
      downloadingAttachments:{},
      projectQuery: "",
      showSuggestions: false,
      filteredProjects: [],
    };
    this.submitModal = this.submitModal.bind(this);
    this.wrapperRef = React.createRef();
  }

  submitModal() {
    this.setState({ reactModalVisible: false });
  }

  onChangePage(currentPage) {
    // update state with new page of items
        this.setState({
      currentPage: currentPage,
      loading: true,
    });
    this.getListOfAttachment(this.state.offset, currentPage);
  }

  // onClickOfAttachment(attachment){
  //   if(attachment.attachmentType == 1){
  //     this.setState((prevState)=>({
  //       downloadingAttachments:{
  //         ...prevState.downloadingAttachments,
  //         [attachment.id]:true,
  //       }
  //     }))
  //       this.props.client
  //           .mutate({
  //               mutation: downloadAttachment,
  //               variables: {
  //                   attachmentId: attachment.id
  //               },
  //               fetchPolicy: "no-cache"
  //           })
  //           .then(result => {
  //               let document = result.data.downloadSubCatAttachment;
  //               var byteCharacters = atob(document.fileData);

  //               var byteNumbers = new Array(byteCharacters.length);
  //               for (var i = 0; i < byteCharacters.length; i++) {
  //               byteNumbers[i] = byteCharacters.charCodeAt(i);
  //               }

  //               var byteArray = new Uint8Array(byteNumbers);

  //               const contentType = mime.lookup(document.fileName.split(".")[1]);

  //               var blob = new Blob([byteArray], {
  //               type: contentType
  //               });

  //               FileSaver.saveAs(blob, document.fileName.substr(32));

  //               this.setState({
  //               errors: [],
  //               loading: false
  //               });
  //               this.setState((prevState) => ({
  //                 downloadingAttachments: {
  //                   ...prevState.downloadingAttachments,
  //                   [attachment.id]: false, // Reset only the clicked attachment/Download file
  //                 },
  //               }));
  //           })
  //           .catch(error => {
  //               console.log("~~~error: ", error);
  //               this.setState({ loading: false, errors: [errorMessage(error)] });
  //               this.setState((prevState) => ({
  //                 downloadingAttachments: {
  //                   ...prevState.downloadingAttachments,
  //                   [attachment.id]: false, 
  //                 },
  //               }));
  //               this.timer = setTimeout(() => {
  //               this.setState({ errors: [] });
  //               }, SET_TIMEOUT_VALUE);
  //           });
  //   }else{
  //     let data = { GridId: attachment.gridId.id };
  //     localStorage.setItem("GridId-Input", JSON.stringify(data));
  //     // this.props.history.push("/grid-input-edit");
  //     window.open("/grid-input-edit");
  //   }
  // }

  // getListOfAttachment(offset, pageNo, ){
  //   let tags = document.getElementById('tag').value;
  //   if(tags != ""){
  //     this.props.client
  //     .query({
  //       query: getListOfAttachmentsByUserId,
  //       variables: {
  //         offset: offset,
  //         pageNo: pageNo,
  //         tags: tags
  //       },
  //       fetchPolicy: "network-only"
  //     })
  //     .then(result => {
  //       var category = result.data.getListOfAttachmentsByUserId;
        
  //       this.initialState = {
  //         pageOfItems: category
  //       };
  //       this.setState({ ...this.initialState, loading: false, error: "", searchedTags: tags });
  //     })
  //     .catch(error => {
  //       this.setState({ loading: false, error: error.message });
  //     });
  //   }else{
  //     this.setState({ pageOfItems: [], searchedTags: tags, tags: tags });
  //   }
  // }
  onClickOfAttachment(attachment) {
    if (attachment.attachmentType == 1) {
      this.setState((prevState)=>({
        downloadingAttachments:{
          ...prevState.downloadingAttachments,
          [attachment.id]:true,
        },
          isdownloading:true
      }))
      this.props.client
        .mutate({
          mutation: downloadAttachment,
          variables: {
            attachmentId: attachment.id,
          },
          fetchPolicy: "no-cache",
        })
        .then((result) => {
          let attachmentData = result.data.downloadSubCatAttachment;

          let presignedUrl = attachmentData?.fileData; // Get pre-signed URL

          let fileName = attachmentData?.fileName;

          if (!presignedUrl || !fileName) {
            console.error("Presigned URL or filename is missing!");
            return;
          }
    
          // Modify filename by removing the first 32 characters
          let modifiedFileName = fileName.length > 32 ? fileName.substr(32) : fileName;

          let link = document.createElement("a");
          link.href = presignedUrl;
          link.setAttribute("download", modifiedFileName); 
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          successMsg("Download Initiated");
          this.setState({
            errors: [],
            loading: false,
            isdownloading:false
          });
          this.setState((prevState) => ({
            downloadingAttachments: {
              ...prevState.downloadingAttachments,
              [attachment.id]: false, // Reset only the clicked attachment/Download file
            },
          }));
        })
        .catch((error) => {
          console.log("~~~error: ", error);
          this.setState({ loading: false, errors: [errorMessage(error)] });
          this.setState((prevState) => ({
            downloadingAttachments: {
              ...prevState.downloadingAttachments,
              [attachment.id]: false, 
            },
          }));
          this.timer = setTimeout(() => {
            this.setState({ errors: [] });
          }, SET_TIMEOUT_VALUE);
        });
    } else {
      let data = { GridId: attachment.gridId.id };
      localStorage.setItem("GridId-Input", JSON.stringify(data));
      // this.props.history.push("/grid-input-edit");
      window.open("/grid-input-edit");
    }
  }

  handleProjectInputChange = (e) => {
  const query = e.target.value;
  const filtered = this.state.projectNameList.filter((project) =>
    (`[${project.projectId}] ${project.name}`.toLowerCase().includes(query.toLowerCase()))
  );

  this.setState({
    projectQuery: query,
    filteredProjects: filtered,
    showSuggestions: true,
    
  });
};

handleSelectProject = (project) => {
  console.log("project",project);
  
  const selectedProjectId = project.id;
  this.setState({
    selectedProject: selectedProjectId,
    projectQuery: `[${project.projectId}] ${project.name}`,
    showSuggestions: false,
    userDetail: {
      ...this.state.userDetail,
      entityType: project.id, 
    },
  });
  // this.getListOfFolders(selectedProjectId);
  
  
  
  
};

handleOutsideClick = (e) => {
  if (
    this.wrapperRef.current &&
    !this.wrapperRef.current.contains(e.target)
  ) {
    this.setState({ showSuggestions: false });
  }
};
  getListOfAttachment(offset, pageNo) {
    let tags = document.getElementById("tag").value;
    if (tags != "") {
      this.props.client
        .query({
          query: getListOfAttachmentsByUserIdForFolderQuery,
          variables: {
            offset: offset,
            pageNo: pageNo,
            tags: tags,
            categoryId:parseInt(this.state.userDetail.entityType),
          },
          fetchPolicy: "network-only",
        })
        .then((result) => {
          var category = result.data.getListOfAttachmentsByUserIdForFolder;
          
          this.initialState = {
            pageOfItems: category,
            
          };
          this.setState({
            ...this.initialState,
            loading: false,
            error: "",
            searchedTags: tags,
          });
        })
        .catch((error) => {
          this.setState({ loading: false, error: error.message });
        });
    } else {
      this.setState({ pageOfItems: [], searchedTags: tags, tags: tags });
    }
  }
  
  getListOfCategory() {
    this.props.client
      .query({
        query: getListOfCategoriesForCategoryViewUserQuery,
        variables: {},
        fetchPolicy: "network-only",
      })
      .then((result) => {
        var category = result.data.getListOfCategoriesForCategoryViewUser;
        const categoryIds = category?.map(item => item?.id);
        if (categoryIds?.length > 0){
          this.initialState = {
            projectNameList: category,
            userDetail: {
              ...this.state.userDetail,
              entityType: categoryIds[0],
            },
            projectQuery:
            categoryIds &&
            `[${category[0].projectId}] ${category[0].name}`,
          };
          this.setState({ ...this.initialState });
        }
      })
      .catch((error) => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, error: error.message });
      });
  }

  handleInput = (e) => {
    this.setState({
      userDetail: {
        ...this.state.userDetail,
        entityType: e.target.value,
      },
    });
  };

  componentDidMount(){
    this.getListOfCategory();
    this.setState({
      loading: true
    });

    this.props.client
      .query({
        query: getAccessPermisionQuery,
        variables: {
          moduleId: CATEGORY_MANAGEMENT_MODULE_ID
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        let response = result.data.getFunctionByModuleId;
        response = JSON.parse(response);
        this.setState({
          accessSpecifier: response[CATEGORY_MANAGEMENT_FEATURE_ID],
          loading: false,
        });
        // this.getListOfAttachment(this.state.offset, this.state.currentPage);  
      })
      .catch(error => {
        this.setState({
          loading: false,
          error: error.message
        });
      });
  }
  
  getCategoryBreadcrumb(categoryStructure){
    var name=""
    categoryStructure = JSON.parse(categoryStructure);
    const arrayLength = categoryStructure.length;
    // var res = categoryStructure.map((data, index)=>{
    for(let i=0; i<arrayLength; i++){
      if (arrayLength === i + 1) {
        // last element
        name = name + categoryStructure[i]
      } else {
        // not last element
        name = name + categoryStructure[i] + " -> "
      }
    }
    // })
    return name;
  }

  render() {
    const {
      loading,
      error,
      accessSpecifier,
      reactModalVisible,
      requireCancel,
      modalMessage,
      pageOfItems,
      tags,
      searchedTags,
      projectId,
      projectNameList,
      userDetail
    } = this.state;
    // const activeProjectOptions = projectNameList.filter(
    //   (project) => project.statusDetail?.name === "Active"
    // );
    if (loading) {
      return <div>Loading...</div>;
    }
    if (error) {
      return <div>{error}</div>;
    }
    return (
        <>
          {accessSpecifier && accessSpecifier.viewP ? (
          <div>
            <ReactModal
              reactModalVisible={reactModalVisible}
              submitModal={this.submitModal}
              modalMessage={modalMessage}
              requireCancel={requireCancel}
            />
            <div className="main-heading info-attachment-list">
                <h1>Document Search</h1>
            </div>
            <section class="main-section pt-0 pl-0 pr-0">
            <div className="search-field">
              <div className="col-md-6 mt-3">
              {/* <div className="form-group">
                  <SelectComponent
                    title={"Project"}
                    name={"Project"}
                    options={projectNameList.map((project) => ({
                      id: project.id,
                      name: `[${project.projectId}]  ${project.name}`,
                    }))}
                    optionKey={"name"}
                    valueKey={"id"}
                    placeholder="Select Project"
                    value={userDetail.entityType || ""}
                    handleChange={this.handleInput} 
                  />
                </div> */}

                <div className="form-group position-relative" ref={this.wrapperRef}>
                  {console.log("handle value",this.state.userDetail.entityType)} 
                  {/* <SelectComponent
                    title={"Project"}
                    name={"Project"}
                    options={projectNameList.map((project) => ({
                      id: project.id,
                      name: `[${project.projectId}]  ${project.name}`, // Concatenating projectId and name
                    }))}
                    optionKey={"name"}
                    valueKey={"id"}
                    placeholder="Select Project"
                    value={userDetail.entityType || ""} 
                    handleChange={this.handleInput} 
                  /> */}

                  <input
                type="text"
                className="form-control"
                placeholder="Type to search project"
                value={this.state.projectQuery}
                onChange={this.handleProjectInputChange}
                onFocus={() => {
                  if (this.state.projectQuery) this.setState({ showSuggestions: true });
                }}
                required
                validator={this.validator}
                validation="required"
                optionKey={"name"}
                valueKey={"id"}
            />

              {this.state.showSuggestions && (
                <ul
                  className="suggestions-list"
                  style={{
                    position: "absolute",
                    top: "90%",
                    left: 0,
                    right: 0,
                    // minWidth:"93%",
                    maxHeight: "auto", //240px
                    overflowY: "auto",
                    border: "1px solid #ccc",
                    backgroundColor: "#fff",
                    zIndex: 1000,
                    listStyleType: "none",
                    margin: 0,
                    padding: 0,
                  }}
      >
      {this.state.filteredProjects.length > 0 ? (
        this.state.filteredProjects.map((project) => (
          // <li
          //   key={project.id}
          //   style={{ padding: "8px", cursor: "pointer" ,backgroundColor: project.id === this.state.selectedProject ? "#f0f0f0" : "#fff" }}
          //   onClick={() => this.handleSelectProject(project)}
          // >
          //   [{project.projectId}] {project.name}
          // </li>
          <li
            key={project.id}
            style={{
              padding: "2px",
              cursor: "pointer",
              backgroundColor:
                project.id === this.state.hoveredProjectId
                  ? "#007bff" // blue on hover
                  : project.id === this.state.selectedProject
                  ? "#f0f0f0" // gray if selected
                  : "#fff",
              
                  
              color:
                project.id === this.state.hoveredProjectId
                  ? "#fff"
                  : "#000",
              fontSize: "15px",
            }}
            onMouseEnter={() => this.setState({ hoveredProjectId: project.id })}
            onMouseLeave={() => this.setState({ hoveredProjectId: null })}
            onClick={() => this.handleSelectProject(project)}
          >
            [{project.projectId}] {project.name}
          </li>
                  ))
                ) : (
                  <li style={{ padding: "8px" }}>No matching projects</li>
                )}
              </ul>
            )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <input type="text" id="tag" className="form-control" value={tags} placeholder="Enter tags to search(minimum 3 characters)" 
                  onChange={(e)=> this.setState({tags: e.target.value})}
                  onKeyUp={(e)=> {
                    if (e.which == 13 || e.keyCode == 13) {
                      e.preventDefault();
                      this.getListOfAttachment(this.state.offset, this.state.currentPage);
                      return false;
                    }
                    return true;
                  }}
                  />
                </div>
              </div>
              <button type="button" className="btn btn-danger m-l-10"
                onClick={()=>this.getListOfAttachment(this.state.offset, this.state.currentPage)}
                >
                  Go
                </button>
              {/* <div className="col-md-2">
                <button type="button" className="btn btn-danger m-l-10"
                onClick={()=>this.getListOfAttachment(this.state.offset, this.state.currentPage)}
                >
                  Go
                </button>
              </div> */}
            </div>
            <div>
              {/* <div className="form-group " style={{padding: '0px', margin: '0px'}}>
                {searchedTags != "" ?
                <span><label style={{marginRight: '5px'}}>Search result for tag: </label>{searchedTags}</span>
                :null}
              </div> */}
            </div>
            <div className="table-responsive">
                <table className="table table-style-1">
                    <thead>
                        <tr>
                            <th scope="col">PROJECT</th>
                            {/* <th scope="col">TYPE</th> */}
                            <th scope="col">NAME</th>
                            <th scope="col">DESCRIPTION</th>
                            <th scope="col">ACTION(s)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pageOfItems.length ?
                          pageOfItems.map((data,index)=>{
                            return(
                              <tr key={index}>
                                <td>{this.getCategoryBreadcrumb(data.categoryStructure)}</td>
                                {/* <td>{data.attachmentType == 1 ? "Document" : "Grid"}</td> */}
                                <td
                                  data-toggle="tooltip" data-placement="bottom" 
                                  title={data.name}
                                >{data.name.length>40 ?data.name.substring(0, 40) + "..." : data.name }</td>
                                <td>{data.description}</td>
                                <td>
                                  {data.attachmentType == 2 ?
                                    <a 
                                      className="link-click" 
                                      href={"/grid-input-edit?id="+data.gridId.id}
                                      target="_blank" 
                                      data-toggle="tooltip" 
                                      data-placement="bottom" 
                                      title="Go To Grid" 
                                      onClick={()=>this.onClickOfAttachment(data)}
                                    >
                                      <img src={gridSvg} alt="" />
                                    </a>
                                    :
                                    <a className="link-click" href="#" data-toggle="tooltip" data-placement="bottom" title="Download"
                                   // onClick={()=>this.onClickOfAttachment(data)}
                                   onClick={() =>{if(!this.state.downloadingAttachments[data.id]){
                                    this.onClickOfAttachment(data)}
                                  }}
                                    >
                                      <img src={downloadSvg} alt="" width="16" style={{opacity:this.state.downloadingAttachments[data.id]? 0.5:1}} />
                                    </a>
                                  }
                                </td>
                              </tr>
                            )
                          })
                          :null}
                    </tbody>
                </table>
            </div>
            {!pageOfItems.length && error ? <div>{error}</div> : null}
            {!pageOfItems.length && loading ? <div>Fetching...</div> : null}
            {!pageOfItems.length && !error && !loading ? (
            <div style={{ textAlign: "center" }}>No Data</div>
            ) : null}
            {/* <Pagination
                loading={loading}
                items={pageOfItems}
                pageSize={this.state.offset}
                initialPage={this.state.currentPage}
                onChangePage={this.onChangePage.bind(this)}
            /> */}
            <div className="row">
              <div className="col-md-2">
              
              </div>
              <div className="col-md-8">
                <Pagination
                  loading={loading}
                  items={pageOfItems}
                  pageSize={this.state.offset}
                  initialPage={this.state.currentPage}
                  onChangePage={this.onChangePage.bind(this)}
                />
              </div>
              <div className="col-md-2 form-group" style={{display: 'flex', marginTop: '8px'}}>
                <label style={{marginTop: '8px'}}>Page Size: </label>
                <select
                  className="form-control"
                  style={{width: '65px'}}
                  onChange={e => {
                    this.setState({ offset: parseInt(e.target.value)},
                    ()=>{
                      this.getListOfAttachment(this.state.offset, this.state.currentPage);
                    }
                    );
                  }}
                >
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                  <option value={25}>25</option>
                </select>
              </div>
            </div>
            </section>
          </div>
        ) : (
          <NotAccessible />
        )}
        </>
    );
  }
}
export default withRouter(withApollo(CategoryList));